import request from '@/utils/request'

//获取副单附件
export function getHouseNoAttachFiles(data) {
    return request({
        url: '/billOfLading/houseNoAttachFiles',
        method: 'post',
        data: data,
        enableLoading: false
    })
}


//获取状态代码列表
export function getStateCodeList(data) {
    return request({
        url: '/billOfLading/stateCodeList',
        method: 'get',
        params: data,
        enableLoading: false
    })
}

//获取提单记录查询处理
export function getBillOfLadingRecords(data) {
    return request({
        url: '/billOfLading/search',
        method: 'post',
        data: data
    })
}

//获取提单记录详情
export function getBillOfLadingRecordDetail(data) {
    return request({
        url: '/billOfLading/detail',
        method: 'get',
        params: data
    })
}